(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda date navigation
    module.directive('agendaDateNavigation', ['DateService', '$translate',
        function (DateService, $translate) {
            var directive = {
                restrict: 'E',
                templateUrl: '/app/agenda/templates/agenda-date-navigation.template.html',
                link: link
            };
            return directive;

            function link(scope, element, attrs) {

                var weekCaption = null;
                scope.date = DateService.getDateCaption();

                if (attrs.week !== undefined) {
                    scope.isWeek = true;
                    $translate('week').then(function (result) {
                        weekCaption = result;
                        dateCaption();
                    });
                }else{
                    scope.isWeek = false;
                }

                // previous
                scope.previousWeek = function (number) {
                    let date = DateService.previousWeek(number);
                    DateService.dateAndReload(date).then(function () { dateCaption(); });
                };
                scope.previousDay = function (number) {
                    let date = DateService.previous(number);
                    DateService.dateAndReload(date).then(function () { dateCaption(); });
                };
                
                scope.today = () => {
                    let date = DateService.getDate();
                    DateService.dateAndReload(date).then(function () { dateCaption(); });
                };

                // next
                scope.nextWeek = function (number) {
                    let date = DateService.nextWeek(number);
                    DateService.dateAndReload(date).then(function () { dateCaption(); });
                };
                scope.nextDay = function (number) {
                    let date = DateService.next(number);
                    DateService.dateAndReload(date).then(function () { dateCaption(); });
                };
                

                // set date caption
                function dateCaption() {
                    if (weekCaption !== null) { scope.date = weekCaption + ' ' + DateService.data.info.week; }
                    else { scope.date = DateService.getDateCaption(); }
                }

            }
        }]);

})();